import { User } from "oidc-client-ts";

export class AuthenticateServiceUser {
	static readonly type = "[Authentication] Authenticate Service User";
}

export class AuthenticateUser {
	static readonly type = "[Authentication] Authenticate User";
	constructor(
		public pin: string,
		public resourceId?: number,
	) {}
}

export class DeleteUserToken {
	static readonly type = "[Authentication] Delete User Token";
}

export class RefreshServiceUserToken {
	public static readonly type = "[Authentication] Refresh Service User Token";
}

export class SetServiceUser {
	static readonly type = "[Authentication] Set ServiceUser";
	constructor(public serviceUser: User | null) {}
}

export class TokenExpired {
	static readonly type = "[Authentication] Token Expired";
	constructor(public redirectToLogin = true) {}
}
